export default __webpack_public_path__ + "static/media/Footer.5f16fc4f.png";